var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1585 7.34369C16.7686 6.9536 16.5403 6.43069 16.5192 5.87951C16.4982 5.32834 16.686 4.78955 17.0451 4.37088C17.0748 4.33606 17.0902 4.2913 17.0883 4.24557C17.0864 4.19985 17.0673 4.15653 17.0348 4.12431L14.9662 2.05338C14.932 2.0192 14.8856 2 14.8373 2C14.7889 2 14.7426 2.0192 14.7084 2.05338L11.4112 5.35056C11.2895 5.47219 11.1979 5.62048 11.1435 5.78369C11.0894 5.94727 10.9978 6.09599 10.8762 6.21804C10.7546 6.34009 10.6062 6.43211 10.4428 6.48681C10.2794 6.54123 10.131 6.63286 10.0092 6.75447L1.55338 15.2084C1.5192 15.2426 1.5 15.2889 1.5 15.3373C1.5 15.3856 1.5192 15.432 1.55338 15.4662L3.62197 17.5348C3.65419 17.5673 3.6975 17.5864 3.74323 17.5883C3.78895 17.5902 3.83371 17.5748 3.86853 17.5451C4.28711 17.1856 4.82603 16.9975 5.37739 17.0184C5.92875 17.0393 6.45187 17.2677 6.84203 17.6579C7.23218 18.048 7.46057 18.5711 7.48148 19.1225C7.50239 19.6739 7.31427 20.2128 6.95478 20.6313C6.92508 20.6662 6.90964 20.7109 6.91155 20.7567C6.91347 20.8024 6.93259 20.8457 6.9651 20.8779L9.03369 22.9465C9.06788 22.9807 9.11425 22.9999 9.1626 22.9999C9.21094 22.9999 9.25731 22.9807 9.2915 22.9465L17.7478 14.4907C17.8694 14.3689 17.961 14.2204 18.0154 14.0571C18.0696 13.8935 18.1611 13.7448 18.2827 13.6228C18.4044 13.5007 18.5528 13.4087 18.7162 13.354C18.8794 13.2996 19.0277 13.208 19.1493 13.0863L22.4465 9.78916C22.4807 9.75496 22.4999 9.7086 22.4999 9.66025C22.4999 9.61191 22.4807 9.56554 22.4465 9.53135L20.3779 7.46275C20.3457 7.43025 20.3024 7.41112 20.2567 7.40921C20.2109 7.4073 20.1662 7.42274 20.1313 7.45244C19.7133 7.81215 19.1748 8.00078 18.6236 7.98061C18.0725 7.96045 17.5492 7.73298 17.1585 7.34369Z",
    stroke: "#2D5D2A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7427 7.08348L10.9688 6.30957",
    stroke: "#2D5D2A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8052 9.14697L13.2891 8.63135",
    stroke: "#2D5D2A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8672 11.2114L15.3516 10.6953",
    stroke: "#2D5D2A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1909 13.5317L17.417 12.7578",
    stroke: "#2D5D2A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.019a88f77eb6bdaeaaf425c7ee4ff68d.svg";
export { ForwardRef as ReactComponent };